import get from "lodash.get";
import { REHYDRATE } from "redux-persist";
import AuthenticationActionTypes from "services/authentication/types";
import ContractActionTypes from "services/contract/types";
import PedestrianStatisticsActionTypes from "./types";

const initialState = {
  filters: {
    timestamp: Math.round(new Date().getTime() / 1000), // today in seconds
    areaType: ["pedestrian"],
    isPedestrianAffluenceChartTimeRangeByHour: true,
    isPedestrianQueueAffluenceChartTimeRangeByHour: true,
    isPedestrianQueueAffluenceMaxChartTimeRangeByHour: true,
    isPedestrianQueueDailyWaitingTimeChartTimeRangeByHour: true,
    range: {
      fromHour: 9 * 3600,
      toHour: 18 * 3600,
    },
    queueRange: {
      fromHour: 9 * 3600,
      toHour: 18 * 3600,
    },
    queueMaxRange: {
      fromHour: 9 * 3600,
      toHour: 18 * 3600,
    },
    queueWaitingTimeRange: {
      fromHour: 9 * 3600,
      toHour: 18 * 3600,
    },
  },
  map: {
    initialized: false,
  },
  general: {
    initialized: false,
  },
  dailyAttendance: {
    initialized: false,
  },
  details: {
    initialized: false,
  },
  queue: {
    dailyAttendance: {
      initialized: false,
      data: {},
    },
    dailyWaitingTime: {
      initialized: false,
      data: {},
    },
    dailyAttendanceMax: {
      initialized: false,
      data: {},
    },
    initialized: false,
  },
  autoRefresh: false,
  initialized: false,
};

const PedestrianStatisticsReducer = (state = initialState, action) => {
  switch (action.type) {
    case REHYDRATE:
      return {
        ...initialState,
        map: {
          ...get(initialState, "map"),
          ...(get(
            action,
            "payload.PedestrianStatistics.map.selectedLayers"
          ) && {
            selectedLayers: [
              ...get(action, "payload.PedestrianStatistics.map.selectedLayers"),
            ],
          }),
        },
      };
    case AuthenticationActionTypes.LOG_OUT:
    case ContractActionTypes.SWITCH_CONTRACT:
      return initialState;
    case PedestrianStatisticsActionTypes.SET_LOADING:
      return {
        ...state,
        [action.statName]: {
          ...state[action.statName],
          initialized: false,
        },
      };
    case PedestrianStatisticsActionTypes.SET_QUEUE_LOADING:
      return {
        ...state,
        queue: {
          ...state.queue,
          [action.statName]: {
            ...state.queue[action.statName],
            initialized: false,
          },
        },
      };
    case PedestrianStatisticsActionTypes.SET_AUTO_REFRESH:
      return {
        ...state,
        autoRefresh: action.autoRefresh,
      };
    case PedestrianStatisticsActionTypes.SET_FILTER:
      return {
        ...state,
        filters: {
          ...state.filters,
          [action.key]: action.value,
        },
      };
    case PedestrianStatisticsActionTypes.SET_FILTERS:
      return {
        ...state,
        filters: action.value,
      };
    case PedestrianStatisticsActionTypes.SET_GENERAL_STATS:
      return {
        ...state,
        general: {
          ...action.stats,
          initialized: true,
        },
      };
    case PedestrianStatisticsActionTypes.SET_DETAILS_STATS:
      return {
        ...state,
        details: {
          ...action.stats,
          initialized: true,
        },
      };
    case PedestrianStatisticsActionTypes.SET_MAP_INFOS:
      return {
        ...state,
        map: {
          ...action.map,
          initialized: true,
        },
      };
    case PedestrianStatisticsActionTypes.SET_SELECTED_LAYERS:
      return {
        ...state,
        map: {
          ...state.map,
          selectedLayers: action.layers,
        },
      };
    case PedestrianStatisticsActionTypes.SET_DAILY_ATTENDANCE_STATS:
      return {
        ...state,
        dailyAttendance: {
          ...action.stats,
          initialized: true,
        },
      };
    case PedestrianStatisticsActionTypes.SET_QUEUE_DAILY_WAITING_TIME_STATS:
      return {
        ...state,
        queue: {
          ...state.queue,
          dailyWaitingTime: {
            data: action.stats,
            initialized: true,
          },
        },
      };
    case PedestrianStatisticsActionTypes.SET_CONFIG:
      return {
        ...state,
        config: action.config || {},
      };
    case PedestrianStatisticsActionTypes.SET_INITIALIZED:
      return {
        ...state,
        initialized: action.value,
      };
    case PedestrianStatisticsActionTypes.SET_QUEUE_DETAILS_STATS:
      return {
        ...state,
        queue: {
          ...state.queue,
          ...action.stats,
          initialized: true,
        },
      };
    case PedestrianStatisticsActionTypes.SET_QUEUE_DAILY_ATTENDANCE_MAX_STATS:
      return {
        ...state,
        queue: {
          ...state.queue,
          dailyAttendanceMax: {
            data: action.stats,
            initialized: true,
          },
        },
      };
    case PedestrianStatisticsActionTypes.SET_QUEUE_DAILY_ATTENDANCE_STATS:
      return {
        ...state,
        queue: {
          ...state.queue,
          dailyAttendance: {
            data: action.stats,
            initialized: true,
          },
        },
      };
    case PedestrianStatisticsActionTypes.SET_QUEUE_DAILY_WAITING_TIME_STATS_ERROR:
      return {
        ...state,
        queue: {
          ...state.queue,
          dailyWaitingTime: {
            ...state.queue.dailyWaitingTime,
            data: [],
            error: action.error,
          },
        },
      };
    case PedestrianStatisticsActionTypes.SET_QUEUE_DAILY_ATTENDANCE_MAX_STATS_ERROR:
      return {
        ...state,
        queue: {
          ...state.queue,
          dailyAttendanceMax: {
            ...state.queue.dailyAttendanceMax,
            data: [],
            error: action.error,
            initialized: true,
          },
        },
      };
    case PedestrianStatisticsActionTypes.SET_QUEUE_DAILY_ATTENDANCE_STATS_ERROR:
      return {
        ...state,
        queue: {
          ...state.queue,
          dailyAttendance: {
            ...state.queue.dailyAttendance,
            data: [],
            error: action.error,
            initialized: true,
          },
        },
      };
    case PedestrianStatisticsActionTypes.SET_QUEUE_DETAILS_STATS_ERROR:
      return {
        ...state,
        queue: {
          ...state.queue,
          initialized: true,
          error: action.error,
        },
      };
    default:
      return state;
  }
};

export default PedestrianStatisticsReducer;
